module.exports = __webpack_public_path__ + "static/img/img05.01b6c3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/126/img05.jpg
// module id = 9rgA
// module chunks = 0